import React from 'react';
import * as S from './TabItem.styles';

const TabItem = (props) => {
	const { label, onClick, activeTab } = props;

  const onClickLabel = () => {
			onClick(label);
	};

	const activeClass = {
		'backgroundColor': '#008cff',
    'borderRadius': '30px',
    'color': '#fff'
	}

	return (
		<S.TabListItem className="tab-list-item" style={activeTab === label ? activeClass : {}} onClick={onClickLabel} isActive={activeTab === label}>
			{label}
		</S.TabListItem>
	);
}

export default TabItem;